export default "__VITE_ASSET__CntBgvia__"